// noinspection JSUnusedGlobalSymbols
// File auto-generated on: 2025-06-03T15:14:56.941Z

import {
    GetStatisticsDashboardSummaryApiResponse,
    GetStatisticsDashboardSummaryApiArg,
    GetStatisticsRequestsApiResponse,
    GetStatisticsRequestsApiArg,
    GetStatisticsSummaryApiResponse,
    GetStatisticsSummaryApiArg,
    GetStatisticsUsageApiResponse,
    GetStatisticsUsageApiArg
} from "~/api/statisticsAPI.types";

import { baseAPI as api } from "~/api/baseAPI";
const injectedRtkApi = api.injectEndpoints({
    endpoints: (build) => ({
        getStatisticsDashboardSummary: build.query<
            GetStatisticsDashboardSummaryApiResponse,
            GetStatisticsDashboardSummaryApiArg
        >({
            query: () => ({ url: "/statistics/dashboard-summary" }),
            extraOptions: {
                security: {
                    api_key_header: [],
                    api_key: [],
                    "jwt-token": [],
                    "jwt-cookie": [],
                    jwt: [],
                },
            },
        }),
        getStatisticsRequests: build.query<
            GetStatisticsRequestsApiResponse,
            GetStatisticsRequestsApiArg
        >({
            query: (queryArg) => ({
                url: "/statistics/requests",
                params: {
                    date: queryArg.date,
                    aggregation: queryArg.aggregation,
                    "user-id": queryArg["user-id"],
                },
            }),
            extraOptions: {
                security: {
                    api_key_header: [],
                    api_key: [],
                    "jwt-token": [],
                    "jwt-cookie": [],
                    jwt: [],
                },
            },
        }),
        getStatisticsSummary: build.query<
            GetStatisticsSummaryApiResponse,
            GetStatisticsSummaryApiArg
        >({
            query: (queryArg) => ({
                url: "/statistics/summary",
                params: {
                    month: queryArg.month,
                    year: queryArg.year,
                    "user-id": queryArg["user-id"],
                },
            }),
            extraOptions: {
                security: {
                    api_key_header: [],
                    api_key: [],
                    "jwt-token": [],
                    "jwt-cookie": [],
                    jwt: [],
                },
            },
        }),
        getStatisticsUsage: build.query<
            GetStatisticsUsageApiResponse,
            GetStatisticsUsageApiArg
        >({
            query: (queryArg) => ({
                url: "/statistics/usage",
                params: {
                    date: queryArg.date,
                    aggregation: queryArg.aggregation,
                    "user-id": queryArg["user-id"],
                },
            }),
            extraOptions: {
                security: {
                    api_key_header: [],
                    api_key: [],
                    "jwt-token": [],
                    "jwt-cookie": [],
                    jwt: [],
                },
            },
        }),
    }),
    overrideExisting: false,
});
export { injectedRtkApi as statisticsAPI };
export const {
    useGetStatisticsDashboardSummaryQuery,
    useLazyGetStatisticsDashboardSummaryQuery,
    useGetStatisticsRequestsQuery,
    useLazyGetStatisticsRequestsQuery,
    useGetStatisticsSummaryQuery,
    useLazyGetStatisticsSummaryQuery,
    useGetStatisticsUsageQuery,
    useLazyGetStatisticsUsageQuery,
} = injectedRtkApi;
